import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate, useLocation } from 'react-router-dom'
import Alert from '../shared/Alert'

const Login = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [errorMessage, setErrorMessage] = useState('')
  const [isEmailLogin, setIsEmailLogin] = useState(true)

  const handleLogin = async (credentials, queryString) => {
    try {
      const response = await fetch('/collectors/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify(credentials),
      })

      const data = await response.json()

      if (!response.ok || data.error) {
        setErrorMessage(data.error || 'An unexpected error occurred')
        return
      }

      const authCheckResponse = await fetch('/collectors/api/check_auth', {
        headers: {
          Accept: 'application/json',
        },
      })

      if (authCheckResponse.ok) {
        navigate(`/collectors/accounts${queryString}`)
      } else {
        setErrorMessage('Login succeeded but session initialization failed. Please try again.')
      }
    } catch (error) {
      console.error('Error during login:', error)
      setErrorMessage('A network error occurred. Please check your connection and try again.')
    }
  }

  useEffect(() => {
    const checkAuthAndToken = async () => {
      try {
        // Get URL params first
        const params = new URLSearchParams(location.search)

        // Create query string without auth_token
        const nonAuthParams = new URLSearchParams()
        params.forEach((value, key) => {
          if (key !== 'auth_token') {
            nonAuthParams.set(key, value)
          }
        })
        const queryString = nonAuthParams.toString() ? `?${nonAuthParams}` : ''

        // Check if already authenticated
        const response = await fetch('/collectors/api/check_auth', {
          headers: {
            Accept: 'application/json',
          },
        })

        if (response.ok) {
          navigate(`/collectors/accounts${queryString}`)
          return
        }

        // If not authenticated, check for auth token
        const authToken = params.get('auth_token')
        if (authToken) {
          await handleLogin({ auth_token: authToken }, queryString)
        }
      } catch (error) {
        console.error('Error in authentication flow:', error)
        setErrorMessage('Error during authentication. Please try again.')
      }
    }

    checkAuthAndToken()
  }, [navigate, location])

  const handleSubmit = e => {
    e.preventDefault()
    const params = new URLSearchParams(location.search)
    const remainingParams = new URLSearchParams()
    params.forEach((value, key) => {
      if (key !== 'auth_token') {
        remainingParams.set(key, value)
      }
    })

    if (isEmailLogin) {
      const email = e.target.email.value
      const password = e.target.password.value
      handleLogin({ email, password }, remainingParams.toString())
    } else {
      const authToken = e.target.auth_token.value
      handleLogin({ auth_token: authToken }, remainingParams.toString())
    }
  }

  return (
    <div className='container mb-10'>
      <div className='row justify-content-center'>
        <div className='col-lg-8'>
          <h1 className='mb-4'>{isEmailLogin ? 'Sign In' : 'Enter Authentication Code'}</h1>

          <p>You can sign in with your email and password or use a login token.</p>

          {errorMessage && <Alert type='danger'>{errorMessage}</Alert>}

          <form onSubmit={handleSubmit}>
            {isEmailLogin ? (
              <>
                <div className='form-group mb-3'>
                  <label htmlFor='email' className='form-label'>
                    Email
                  </label>
                  <input type='email' id='email' name='email' className='form-control' required />
                </div>
                <br />
                <div className='form-group mb-3'>
                  <label htmlFor='password' className='form-label'>
                    Password
                  </label>
                  <input
                    type='password'
                    id='password'
                    name='password'
                    className='form-control'
                    required
                  />
                </div>
              </>
            ) : (
              <div className='form-group mb-3'>
                <label htmlFor='auth_token' className='form-label'>
                  Authentication Code
                </label>
                <input
                  type='text'
                  id='auth_token'
                  name='auth_token'
                  className='form-control'
                  placeholder='123ABC'
                />
              </div>
            )}

            <div className='form-group mb-3'>
              <button type='submit' className='btn btn-primary w-100'>
                Sign In
              </button>
            </div>
          </form>

          <Link
            to='#'
            style={{ padding: '0px' }}
            className='btn btn-link'
            onClick={e => {
              e.preventDefault()
              setIsEmailLogin(!isEmailLogin)
            }}
          >
            {isEmailLogin ? 'Have a login token?' : 'Back to email login'}
          </Link>
          <br />
          <a href='/users/password/new' style={{ padding: '0px' }} className='btn btn-link'>
            Forgot your password?
          </a>
        </div>
      </div>
    </div>
  )
}

export default Login
